// extracted by mini-css-extract-plugin
export default {"signUpHeader":"signUpHeader__lb54Ih","signUpFooter":"signUpFooter__OnbOlp","signUpSteps":"signUpSteps__FexEkH"};